module.exports = __webpack_public_path__ + "01_veryshort_brown.61d9b0d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/01_veryshort_brown.png
// module id = CD0H
// module chunks = 0